import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Grid } from '@mui/material';
import ComponentPageHeader from '../../../Common/PageHeader/ComponentPageHeader';
import english from '../../../assets/lang/english';
import DataTable from '../../../Common/DataTable';
import { FIRST_SELECTED_TAB, JobUnScheduleTableColumns } from './utils/constants';
import { JobsScheduleTableData } from './utils/types';
import { formatJobsData, formatJobsDataXl } from './utils/helper';
import {
  getJobScheduleListData, resetJobScheduleState, setNavigateFromScheduleTab, setSelectedTab,
} from './addJob/redux/jobScheduleSlice';
import { RootState } from '../../../redux/rootState';
import { setLoader } from '../../../redux/loaderSlice';
import { Empty } from '../../ScreenAddSmc/Utils/TypeSmc';
import { exportToExcelData } from '../../../Common/PageHeader/helper';
import {
  resetPagination, setPageNumber, setPageSize, setSearchParam,
} from '../../taiReportingSystem/redux/sliceReportWorkspace';

function UnscheduledJobs() {
  const navigate = useNavigate();
  // const [page, setPage] = useState(1);
  // const [rowsPerPage, setRowsPerPage] = useState(10);
  // const [searchQuery, setSearchQuery] = useState('');
  const dispatch = useDispatch();
  const {
    pageNumber, pageSize, searchParam,
  } = useSelector((state: RootState) => state.reportWorkspaceReducer);
  const { jobScheduleData, isLoading } = useSelector((state: RootState) => state.jobScheduleReducer);
  const { historyStack } = useSelector((state:RootState) => state.masterDataReducer);

  const handleData = () => {
    const payload = {
      page: pageNumber,
      searchQuery: searchParam,
      rowsPerPage: pageSize,
      type: 2,
    };
    dispatch(getJobScheduleListData(payload));
  };

  useEffect(() => {
    dispatch(setLoader(isLoading));
  }, [isLoading]);

  useEffect(() => () => {
    dispatch(resetJobScheduleState());
  }, []);
  useEffect(() => {
    handleData();
  }, [pageNumber, pageSize, searchParam]);

  const handleScheduleClick = (row: Empty) => {
    dispatch(setSelectedTab(FIRST_SELECTED_TAB));
    dispatch(setNavigateFromScheduleTab(false));
    navigate(`${row?.id}/${row?.jobId}`);
  };

  const downloadExcel = () => {
    exportToExcelData(
      {
        data: formatJobsDataXl(jobScheduleData?.Data),
      },
      'JobsUnSchedule_list',
    );
  };

  useEffect(() => {
    if (historyStack) {
      const finderString = '/unscheduled-jobs/';
      const last = historyStack[historyStack.length - 1];
      const sLast = historyStack[historyStack.length - 2];
      if (!(last?.includes(finderString) || (sLast?.includes(finderString) && last?.includes('unscheduled-jobs')))) {
        dispatch(resetPagination());
      }
    }
  }, [historyStack]);

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={12} md={12}>
        <ComponentPageHeader subHeading={String(english.UnscheduledJobs)} downloadExcel={downloadExcel} />
      </Grid>
      <Grid item xs={12} sm={12} md={12} className="dataTableCustomMargin">
        <DataTable<JobsScheduleTableData>
          data={formatJobsData(jobScheduleData?.Data)}
          columns={JobUnScheduleTableColumns}
          totalRecords={jobScheduleData?.TotalRecords}
          page={pageNumber}
          setPage={(e) => { dispatch(setPageNumber(e)); }}
          rowsPerPage={pageSize}
          setRowsPerPage={(e) => { dispatch(setPageSize(e)); }}
          searchQuery={searchParam}
          setSearchQuery={(e) => { dispatch(setSearchParam(e)); dispatch(setPageNumber(1)); }}
          handleData={handleData}
          handleScheduleClick={handleScheduleClick}
          handleDataFromComponent
        />
      </Grid>
    </Grid>
  );
}

export default UnscheduledJobs;
